<template>
   <v-app>
      <v-app-bar
      app
      absolute
      color="grey darken-4"
      elevate-on-scroll
    >

    <a href="https://www.owid.de/plus/"><img class="mr-3" :src="require('../public/owidplus_logo.svg')" height="40"/></a>
       <v-spacer></v-spacer>
      <v-toolbar-title ><h1 class="font-weight-light">
</h1></v-toolbar-title>
      <v-spacer></v-spacer>
      <a  href="https://www.ids-mannheim.de"><img class="mr-3" :src="require('../public/ids_logo.svg')" height="80"/></a>
    </v-app-bar>

   <v-main >
       <Index/>
   </v-main>
  </v-app>
</template>

<script>
import Index from './components/Index';

export default {
  name: 'App',

  components: {
    Index,
  },

  data: () => ({
    //
  }),
};
</script>
